// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3069":"c91eaa23","4828":"5abfa991"}[chunkId] + ".chunk.css";
};